import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { apiFetch } from './api';

const IS_NATIVE = Capacitor.isNativePlatform();

/// Request APNs permission and hand the device token to the backend.
/// Called after sign-in. No-op on web — web uses the existing VAPID flow.
export async function registerNativePush() {
  if (!IS_NATIVE) return;

  try {
    const perm = await PushNotifications.checkPermissions();
    let granted = perm.receive === 'granted';
    if (!granted) {
      const req = await PushNotifications.requestPermissions();
      granted = req.receive === 'granted';
    }
    if (!granted) return;

    await PushNotifications.register();
  } catch (e) {
    console.warn('[push] register failed', e);
  }
}

let _listenersAttached = false;
export function attachPushListeners() {
  if (!IS_NATIVE || _listenersAttached) return;
  _listenersAttached = true;

  PushNotifications.addListener('registration', async (tok) => {
    try {
      await apiFetch('/push/register-device', {
        method: 'POST',
        body: JSON.stringify({
          deviceToken: tok.value,
          platform: 'ios',
          bundleId: 'app.daysheets',
          appVariant: 'admin',
        }),
      });
    } catch (e) {
      console.warn('[push] register-device failed', e);
    }
  });

  PushNotifications.addListener('registrationError', (err) => {
    console.warn('[push] registrationError', err);
  });

  PushNotifications.addListener('pushNotificationReceived', (notif) => {
    // Foreground receipt — the native layer already shows the banner.
    // Could fire a toast here if we want extra UX on top.
    console.log('[push] received', notif);
  });

  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    // Tapped a notification — deep-link into the relevant sheet if provided.
    const url = action.notification?.data?.url;
    if (typeof url === 'string' && url.startsWith('/')) {
      window.location.assign(url);
    }
  });
}
